export const GET_WOMENDATA_REQUEST = "GET_WOMENDATA_REQUEST";
export const GET_WOMENDATA_SUCCESS = "GET_WOMENDATA_SUCCESS";
export const GET_WOMENDATA_FAILURE = "GET_WOMENDATA_FAILURE";
